import { createContext } from 'react';

/** Layout state of the Network Overview table beside the Find & Fix map. */
export type TableViewLayout = 'closed' | 'split' | 'maximised';

export interface TableViewContextValue {
    /** Current layout of the table region. */
    layout: TableViewLayout;
    /** True whenever the table is showing (split or maximised). */
    isOpen: boolean;
    /** Open the table into the 50/50 split (from closed; no-op if already open). */
    open: () => void;
    /** Close the table, returning the map to full width. */
    close: () => void;
    /** Grow the table to fill the workspace, hiding the map. */
    maximise: () => void;
    /** Restore the 50/50 split from the maximised state. */
    restoreSplit: () => void;
    /** Open into split when closed, otherwise close. */
    toggle: () => void;
}

export const TableViewContext = createContext<TableViewContextValue | null>(null);
